import * as $ from "jquery";
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {formatCurrency} from 'Core/Currencies';

/** ref: src/libs/Services/DeliveryMethods/Enum/DeliveryMethodsEnum.php */
enum DELIVERY_METHODS {
    /**
     * 19 - Odbiór osobisty w salonie
     */
    DELIVERY_OWN_RECEPTION = 19,
    /**
     * 20 - Kurier
     */
    DELIVERY_COURIER = 20,
    /**
     * 21 - Transport własny
     */
    DELIVERY_OWN_TRANSPORT = 21
}

export class Step1Component {

    static Selector = Step1Selectors;

    public static handleDeliveryBarUpdate(basket_value: number, deliveryMethods): void {
        // methods of delivery from ajax request
        let deliveryArray = [];
        typeof deliveryMethods.delivery_methods !== 'undefined' ? deliveryArray = deliveryMethods.delivery_methods : deliveryArray = [];
	
        // prepare array with every delivery bar containers
        const barContainers = document.querySelectorAll(Step1Component.Selector.DELIVERY_BAR.DELIVERY_CONTAINER);
        
        barContainers.forEach(barElement => {
            // get minumum basket value for free transport
            const endValue: number = $(barElement).find(Step1Component.Selector.DELIVERY_BAR.END).data('value');
            const deliveryMethodId = Number($(barElement).data('delivery-method'));

            // make calculations next steps
            let { missing = 100, barWidth = 0 } = Step1Component.calculations(basket_value, endValue);

            if (missing <= 0) {
                missing = 0;
                barWidth = 100;
            }

            Step1Component.setDeliveryValues(barElement, missing, barWidth);

            //only for removing from cart
            if (deliveryArray.length != 0) {
                Step1Component.handleBarVisibilityChange(barElement, deliveryArray);
            }

            if (
                deliveryMethodId && 
                $(`.delivery_method_${deliveryMethodId}`).is(':visible') &&
                (deliveryMethodId === DELIVERY_METHODS.DELIVERY_COURIER || deliveryMethodId === DELIVERY_METHODS.DELIVERY_OWN_TRANSPORT)
            ) {
                // toggle the bar color
                $(this.Selector.DELIVERY_BAR.BAR).toggleClass('fulfilled', missing === 0);
                // toggle the text
                this.toggleMissingValueAndItsText(missing);
            }
        });
    }

    private static calculations(basket: number, end: number) {
        const missing: number = end - basket; 
        const barWidth: number = basket / end * 100; // current width of value bar
        return { missing, barWidth } as const; 
    }

    private static toggleMissingValueAndItsText(missingValue: number) {
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE_TEXT.NOT_YET).toggle(missingValue !== 0);
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE_TEXT.FULFILLED).toggle(missingValue === 0);
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE).toggle(missingValue !== 0);
    }

    private static setDeliveryValues(
        element: Element, 
        missing_value: number, 
        bar_width: number
    ): void {   
        $(element).find(Step1Component.Selector.DELIVERY_BAR.MISSING_VALUE).attr('data-value', missing_value).text(formatCurrency(missing_value));
        $(element).find(Step1Component.Selector.DELIVERY_BAR.BAR).css("width", bar_width+'%');
    }

    public static handleBarVisibilityChange(item: Element, deliveryArray: any[]) {
        // loop deliveryArray contains information about current active methods (for products in cart)
        for (const id in deliveryArray) {
            // hide delivery method with specific id
            if (deliveryArray[id] == false && item.classList.contains(`delivery_method_${id}`)) {
                item.classList.remove('d-block');
                item.classList.add('d-none');
            }
            //show delivery method with specific id
            if (deliveryArray[id] == true && item.classList.contains(`delivery_method_${id}`)) {
                item.classList.remove('d-none');
                item.classList.add('d-block');
            }
        
        }
    }
}
import * as $ from "jquery";
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {formatCurrency} from 'Core/Currencies';

/** ref: src/libs/Services/DeliveryMethods/Enum/DeliveryMethodsEnum.php */
enum DELIVERY_METHODS {
    /**
     * 19 - Odbiór osobisty w salonie
     */
    DELIVERY_OWN_RECEPTION = 19,
    /**
     * 20 - Kurier
     */
    DELIVERY_COURIER = 20,
    /**
     * 21 - Transport własny
     */
    DELIVERY_OWN_TRANSPORT = 21
}

export class Step1Component {

    static Selector = Step1Selectors;

    public static handleDeliveryBarUpdate(basket_value: number, deliveryMethods): void {
        // methods of delivery from ajax request
        let deliveryArray = [];
        typeof deliveryMethods.delivery_methods !== 'undefined' ? deliveryArray = deliveryMethods.delivery_methods : deliveryArray = [];
	
        // prepare array with every delivery bar containers
        const barContainers = document.querySelectorAll(Step1Component.Selector.DELIVERY_BAR.DELIVERY_CONTAINER);
        
        barContainers.forEach(barElement => {
            // get minumum basket value for free transport
            const endValue: number = $(barElement).find(Step1Component.Selector.DELIVERY_BAR.END).data('value');
            const deliveryMethodId = Number($(barElement).data('delivery-method'));

            // make calculations next steps
            let { missing = 100, barWidth = 0 } = Step1Component.calculations(basket_value, endValue);

            if (missing <= 0) {
                missing = 0;
                barWidth = 100;
            }

            Step1Component.setDeliveryValues(barElement, missing, barWidth);

            //only for removing from cart
            if (deliveryArray.length != 0) {
                Step1Component.handleBarVisibilityChange(barElement, deliveryArray);
            }

            if (
                deliveryMethodId && 
                $(`.delivery_method_${deliveryMethodId}`).is(':visible') &&
                (deliveryMethodId === DELIVERY_METHODS.DELIVERY_COURIER || deliveryMethodId === DELIVERY_METHODS.DELIVERY_OWN_TRANSPORT)
            ) {
                // toggle the bar color
                $(this.Selector.DELIVERY_BAR.BAR).toggleClass('fulfilled', missing === 0);
                // toggle the text
                this.toggleMissingValueAndItsText(missing);
            }
        });
    }

    private static calculations(basket: number, end: number) {
        const missing: number = end - basket; 
        const barWidth: number = basket / end * 100; // current width of value bar
        return { missing, barWidth } as const; 
    }

    private static toggleMissingValueAndItsText(missingValue: number) {
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE_TEXT.NOT_YET).toggle(missingValue !== 0);
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE_TEXT.FULFILLED).toggle(missingValue === 0);
        $(this.Selector.DELIVERY_BAR.MISSING_VALUE).toggle(missingValue !== 0);
    }

    private static setDeliveryValues(
        element: Element, 
        missing_value: number, 
        bar_width: number
    ): void {   
        $(element).find(Step1Component.Selector.DELIVERY_BAR.MISSING_VALUE).attr('data-value', missing_value).text(formatCurrency(missing_value));
        $(element).find(Step1Component.Selector.DELIVERY_BAR.BAR).css("width", bar_width+'%');
    }

    public static handleBarVisibilityChange(item: Element, deliveryArray: any[]) {
        // loop deliveryArray contains information about current active methods (for products in cart)
        for (const id in deliveryArray) {
            // hide delivery method with specific id
            if (deliveryArray[id] == false && item.classList.contains(`delivery_method_${id}`)) {
                item.classList.remove('d-block');
                item.classList.add('d-none');
            }
            //show delivery method with specific id
            if (deliveryArray[id] == true && item.classList.contains(`delivery_method_${id}`)) {
                item.classList.remove('d-none');
                item.classList.add('d-block');
            }
        
        }
    }
}
